import _get from "lodash/get";
import _isEmpty from "lodash/isEmpty";
import { Middleware } from "redux";
import * as AT from "./actionTypes";
import * as B2B_AT from "./actionTypesB2B";
import * as util from "./middleware.util";
import { isChildSubscription } from "./selectors/subscriptionsSelectors";
import { FORM_ID } from "../../../../constants";
import { actionTypes as AUTH_AT } from "../../authentication";
import { actionTypes as RF_AT } from "../../rapidform";
import { fulfilled } from "../utils";

/**
 * Middleware will listen for value changed actions emitted by the personalDetailsForm
 */
export default function checkoutMiddleware(): Middleware {
    return (store) => (next) => (action) => {
        // A value change for an input within personalDetailsForm
        if (RF_AT.FORM_VALUE_CHANGED(FORM_ID.PERSONAL_DETAILS) === action.type) {
            util.handleFormValueChanged(store, action, FORM_ID.PERSONAL_DETAILS);
        }

        // A value change for an input within addMemberForm
        if (RF_AT.FORM_VALUE_CHANGED(FORM_ID.ADD_MEMBER) === action.type) {
            util.handleFormValueChanged(store, action, FORM_ID.ADD_MEMBER);
        }

        if (RF_AT.FORM_VALUE_CHANGED(FORM_ID.EDIT_DELIVERY_ADDRESS) === action.type) {
            util.handleFormValueChanged(store, action, FORM_ID.EDIT_DELIVERY_ADDRESS);
        }

        // A value change for an input within customerProductUserForm
        if (RF_AT.FORM_VALUE_CHANGED(FORM_ID.CUSTOMER_PRODUCT_USER) === action.type) {
            util.handleFormValueChanged(store, action, FORM_ID.CUSTOMER_PRODUCT_USER);
        }

        // A value change for an input within creditCheckForm (e.g. manual address postcode)
        if (RF_AT.FORM_VALUE_CHANGED(FORM_ID.CREDIT_CHECK) === action.type) {
            util.handleFormValueChanged(store, action, FORM_ID.CREDIT_CHECK);
        }

        // Populate personalDetails form with BankId data
        if (fulfilled(AUTH_AT.AUTH_BANK_ID_GRANT) === action.type) {
            util.populateFormFieldsFromBankIdResult(store, action);
        }

        // Populate personalDetails form with legalOwner after verify success
        if (fulfilled(AT.CHECKOUT_VERIFY_CODE_TRANSFER_OWNERSHIP) === action.type) {
            util.populateFormFieldsFromVerifyCodeSuccess(store, action);
        }

        // Populate addMember form with existing member data
        if (fulfilled(AT.CHECKOUT_CHECK_NEW_MEMBER_PHONE_NUMBER) === action.type) {
            const state = store.getState();
            const subscriptionId = _get(action, "payload.id");
            const isChild = isChildSubscription(state, subscriptionId);

            if (!_isEmpty(_get(action, "payload.productUser", null)) && !isChild) {
                util.populateFormFieldsFromAddExistingMember(store, action);
            }
        }

        // Populate businessDetailsForm with data from brreg
        if (fulfilled(B2B_AT.B2B_CHECK_ORGANIZATION_NUMBER) === action.type) {
            util.populateFormFieldsFromBrregLookup(store, action);
        }

        // Update vouchers when cart changes
        if (
            fulfilled(AT.CHECKOUT_SET_DELIVERY_TYPE) === action.type ||
            fulfilled(AT.CHECKOUT_ADD_ACCESSORY_TO_CART) === action.type ||
            fulfilled(AT.CHECKOUT_ADD_SERVICE_TO_CART) === action.type ||
            fulfilled(AT.CHECKOUT_REMOVE_SERVICE_FROM_CART) === action.type ||
            fulfilled(AT.CHECKOUT_REMOVE_ITEM_BY_CART_ITEM_ID_FROM_CART) === action.type
        ) {
            util.handleCartUpdated(store);
        }

        return next(action);
    };
}
